import React, { useEffect } from 'react';
import { setTicketViewMountStatus } from 'flow/actions/tickets-action';
import { TicketParams } from 'flow/types/Params';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';
import useTicketFetchOnTicketViewMount from 'flow/hooks/useTicketFetchOnTicketViewMount';
import ContentWrapper from 'flow/route-components/ContentWrapper';
import Loading from 'flow/components/ui-components/Loading';
import Ticket from 'flow/components/tickets/Ticket';
import TicketAccessMissingPage from 'flow/components/tickets/TicketAccessMissingPage';

const TicketOverview = () => {
    const { ticketKey } = useParams<TicketParams>();
    const dispatch = useAppDispatch();

    const { accessToTicketMissing, ticketIsFetched: ticketExistsInStore } =
        useTicketFetchOnTicketViewMount(ticketKey);

    useEffect(() => {
        dispatch(setTicketViewMountStatus(true, ticketKey, 'page'));
        return () => {
            dispatch(setTicketViewMountStatus(false, ticketKey, 'page'));
        };
    }, [dispatch, ticketKey]);

    if (!ticketExistsInStore && !accessToTicketMissing) {
        return <Loading />;
    }

    return (
        <ContentWrapper>
            {accessToTicketMissing ? <TicketAccessMissingPage /> : <Ticket />}
        </ContentWrapper>
    );
};

export default React.memo(TicketOverview);
